var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-1 noselect d-flex align-items-center"},[_c('font-awesome-icon',{attrs:{"icon":_vm.name,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }